const PERMISSIONS_KEY = 'PERMISSIONS';


export const useStorage = () => {
  const getPermissions = () => JSON.parse(localStorage.getItem(PERMISSIONS_KEY) || '{}');

  return { getPermissions };
};
